<template>
  <div class="wrapper">
    <h1 class="current-list-title">
      {{active.name}}
      <i @click="showModal" class="material-icons">add_circle_outline</i>
    </h1>
    <div class="task_wrapper">
      <transition-group name="trgroup" :key="active.name">
        <task v-for="task in tasks" :key="task.id" :data="task" v-if="showUndoneTasks(task)" @animationright="animationType='animationright'" @animationleft="animationType='animationleft'" :class="[animationType]"></task>
      </transition-group>
      <h5 v-if="isDoneTasks" class="completed-title">Completed tasks:</h5>
      <task v-for="task in tasks" :key="task.id" :data="task" v-if="showDoneTasks(task)"></task>
      <h5 v-if="!isTaskInList" class="no-task-title">There are no tasks in the list!</h5>
    </div>
    <modal v-if="modalDisplay" @close="closeModal">
      <h5>Create new task</h5>
      <input @keyup.enter="!isDisable && createTask()" type="text" v-model="insertedTitle" placeholder="Add title" ref="input">
      <textarea id="textarea1" class="materialize-textarea" v-model="insertedText" placeholder="Add new description"></textarea>
      <div class="button-wrapper">
        <a @click="closeModal" class="waves-effect waves-light btn btn-delete"><i class="material-icons">cancel</i></a>
        <a @click="createTask" :disabled="isDisable" class="waves-effect waves-light btn btn-complete"><i class="material-icons">done</i></a>
      </div>
    </modal>
  </div>
</template>

<script>
  import task from './task'
  import modal from './modal'
  
  export default {
    data() {
      return {
        modalDisplay: false,
        insertedTitle: '',
        insertedText: '',
        animationType: ''
      }
    },
    computed: {
      active() {
        return this.$store.getters.active
      },
      tasks() {
        let reversedTasks = this.$store.getters.tasks.slice().reverse()
        return reversedTasks
      },
      isDisable() {
        return this.insertedTitle === ''
      },
      isDoneTasks() {
        return !!this.tasks.some(elem => elem.list === this.active.id && elem.done === true)
      },
      isTaskInList() {
        return !!this.tasks.some(elem => elem.list === this.active.id)
      }
    },
    components: {
      task,
      modal
    },
    methods: {
      showUndoneTasks(task) {
        return task.list === this.active.id && task.done === false
      },
      showDoneTasks(task) {
        return task.list === this.active.id && task.done === true
      },
      showModal() {
        this.modalDisplay = true
        setTimeout(() => this.$refs.input.focus(), 100)
      },
      closeModal() {
        this.modalDisplay = false
        this.clearFields()
      },
      clearFields() {
        this.insertedTitle = ''
        this.insertedText = ''
      },
      createTask() {
        this.$store.dispatch('createTask', {
          name: this.insertedTitle,
          text: this.insertedText,
          list: this.active.id
        })
        this.closeModal()
      },
      cons() {
        console.log(111)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
  }
  
  .current-list-title {
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    font-size: 2rem;
    i {
      padding-right: 20px;
      font-size: 29px;
      transition: color .5s;
      cursor: pointer;
      &:hover {
        color: #e53935;
      }
    }
  }
  
  .task_wrapper {
    display: flex;
    flex-direction: column;
  }
  
  .button-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  
  .completed-title {
    opacity: .3;
    padding-left: 20px;
  }
  
  .no-task-title {
    padding-left: 20px;
    text-align: center;
    color: #a9a9a9e6;
    margin-top: 30px;
  }
  
  .trgroup-move {
    // transition: all 5s;
  }
  
  .trgroup-leave-to.animationleft {
    transform: translateX(-700px);
    opacity: 0;
  }
  
  .trgroup-leave-to.animationright {
    transform: translateX(700px);
    opacity: 0;
  }
  
  .trgroup-leave-active {
    position: absolute;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/main.vue